import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { SMART_EDIT_FEATURE, SmartEditConfig, SmartEditRootModule } from '@spartacus/smartedit/root';

@NgModule({
  declarations: [],
  imports: [SmartEditRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [SMART_EDIT_FEATURE]: {
          module: () => import('@spartacus/smartedit').then((m) => m.SmartEditModule),
        },
      },
    }),
    provideConfig(<SmartEditConfig>{
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin:
          'backoffice.c5vp9gk-shimanoin2-d1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin2-s1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin2-p1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin1-d1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin1-s1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin1-p1-public.model-t.cc.commerce.ondemand.com:443,backoffice.cf17gzmnam-shimanosh1-d1-public.model-t.ccv2prod.sapcloud.cn:443,backoffice.cf17gzmnam-shimanosh1-s1-public.model-t.ccv2prod.sapcloud.cn:443,backoffice.cf17gzmnam-shimanosh1-p1-public.model-t.ccv2prod.sapcloud.cn:443,backoffice.c5vp9gk-shimanoin2-d3-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin1-d3-public.model-t.cc.commerce.ondemand.com:443,backoffice.cf17gzmnam-shimanosh1-d3-public.model-t.ccv2prod.sapcloud.cn:443,backoffice.c5vp9gk-shimanoin4-d2-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin4-s1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin4-d1-public.model-t.cc.commerce.ondemand.com:443,backoffice.c5vp9gk-shimanoin4-p1-public.model-t.cc.commerce.ondemand.com:443',
      },
    }),
  ],
})
export class SmartEditFeatureModule {}
